import { setModalOpen } from "@/store/slices/modalSlice";
import { store } from "@/store/store";

// This interface is incomplete. Check here for a list of all fields https://developer.helpscout.com/beacon-2/web/javascript-api/#beaconconfig-formobject
interface Config {
  display?: {
    zIndex?: number;
    horizontalMobileOffset?: number;
    verticalMobileOffset?: number;
  };
}

interface UserData {
  name: string;
  email: string;
  jobTitle: string | undefined;
  "organisation-id": number;
  "organisation-name": string;
  signature: string;
}
interface MessageConfig {
  force?: boolean;
  delay?: number;
}
type Event =
  | "open"
  | "close"
  | "ready"
  | "article-viewed"
  | "chat-started"
  | "email-sent"
  | "message-clicked"
  | "message-closed"
  | "message-triggered"
  | "search";
type BeaconFunc = (
  type: "init" | "open" | "close" | "toggle" | "identify" | "on" | "off" | "config" | "article" | "ask-question" | "show-message",
  arg?: UserData | Event | string | Config | MESSAGE_ID,
  arg2?: (() => void) | MessageConfig
) => void;

let hasBeenInitialised = false;

const hasBeacon = (window: unknown): window is { Beacon: BeaconFunc } => {
  return typeof window === "object" && window != null && "Beacon" in window && typeof window.Beacon === "function";
};

export const BEACON_MODAL_NAME = "beacon_modal";
export const BeaconDefaultConfig: Config = {
  display: {
    horizontalMobileOffset: 20,
    verticalMobileOffset: 20,
    zIndex: 9999
  }
};

export const PRODUCT_ISSUE_FEEDBACK_MESSAGE_ID: MESSAGE_ID = "434546e4-b714-4363-a10f-896c1fd0a454";
export type MESSAGE_ID = "434546e4-b714-4363-a10f-896c1fd0a454";

export const Beacon: BeaconFunc = (type, arg, arg2) => {
  if (!hasBeacon(window)) {
    return;
  }

  if (type === "init") {
    if (hasBeenInitialised) {
      return;
    }

    Beacon("on", "open", () => store.dispatch(setModalOpen({ name: BEACON_MODAL_NAME, value: true })));
    Beacon("on", "close", () => store.dispatch(setModalOpen({ name: BEACON_MODAL_NAME, value: false })));

    Beacon("config", BeaconDefaultConfig);

    hasBeenInitialised = true;
  }

  window.Beacon(type, arg, arg2);
};
